import { AttioCompanyResponse, TextValue } from '../attio.types';
import { BaseAttioService } from './BaseAttioService';

// Service-specific types
export interface AttioCompanyData {
  companyId: string;
  companyName: string;
  companyUrl: string;
  primaryContactId?: string;
  salesRepId?: string;
  notes?: TextValue[];
}

export class AttioCompanyService extends BaseAttioService {
  constructor() {
    super('AttioCompanyService');
  }

  /**
   * Get company details by entity record ID
   */
  async getCompanyByEntityRecordId(companyRecordId: string): Promise<AttioCompanyResponse> {
    try {
      const response = await this.get<AttioCompanyResponse>(this.endpoints.retrieveEntityRecordId(companyRecordId));
      return response;
    } catch (error) {
      this.handleError(error, 'getCompanyByEntityRecordId');
      throw error;
    }
  }

  /**
   * Get company data with extracted information
   */
  async getCompanyData(companyRecordId: string): Promise<AttioCompanyData> {
    try {
      const response = await this.getCompanyByEntityRecordId(companyRecordId);
      const companyData = response.data.values;

      return {
        companyId: companyRecordId,
        companyName: companyData.name?.[0]?.value || '-',
        companyUrl: response.data.web_url,
        primaryContactId: companyData.primary_contact?.[0]?.target_record_id,
        salesRepId: companyData.sales_rep?.[0]?.referenced_actor_id,
        notes: companyData.notes,
      };
    } catch (error) {
      this.handleError(error, 'getCompanyData');
      throw error;
    }
  }
}
